import styled from "styled-components";
import { isMobile } from "../../utils/utils";
import classNames from "classnames";
import { useCallback, useState } from "react";

const FilterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 70px;
  margin-right: 32px;
  div {
    position: initial;
    bottom: 0px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    border-radius: 4px;
    background-color: rgba(85, 119, 253, 0.1);
    font-size: 14px;
    font-weight: 600;
    color: rgb(224, 236, 255);
    width: 96px;
    border: 1px solid rgba(85, 119, 253, 0.1);
    height: 32px;
    margin-left: 8px;
    cursor: pointer;
  }
  .selected {
    border: 1px solid rgb(205, 122, 55);
  }
`;
const Filter = ({
  onChange,
  cycleArr = ["7D", "30D"],
  className = "",
  defaultValue = cycleArr[cycleArr.length - 1]
}: {
  onChange: (text: string) => void;
  cycleArr: Array<string>;
  className?: string;
  defaultValue?: string;
}) => {
  const cycle = cycleArr;
  const filterButtonWidth = isMobile() ? 64 : 96;
  const [value, setValue] = useState(defaultValue);
  const onClick = useCallback(
    (text: string) => {
      onChange && onChange(text);
      setValue(text);
    },
    [onChange]
  );

  return (
    <FilterWrapper className={className}>
      {cycle.map((item, index) => {
        return (
          <div
            key={index}
            className={classNames(className, {
              selected: item === value,
            })}
            onClick={() => onClick(item)}
          >
            {item}
          </div>
        );
      })}
    </FilterWrapper>
  );
};
export default Filter;
